import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CustomPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(`${API}/custom-pages/${slug}`);
        setPage(res.data);
      } catch (err) {
        setError(err.response?.status === 404 ? 'Page not found' : 'Failed to load page');
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[var(--primary)]" />
      </div>
    );
  }

  if (error || !page) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] gap-4">
        <h1 className="text-2xl font-bold text-stone-700">{error || 'Page not found'}</h1>
        <Button variant="outline" onClick={() => navigate('/')}>Go Home</Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <div className="max-w-4xl mx-auto px-4 py-12 md:py-20">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-stone-500 hover:text-[var(--primary)]"
          data-testid="custom-page-back"
        >
          <ArrowLeft size={18} className="mr-2" /> Back
        </Button>

        <h1
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-[var(--primary)] mb-8"
          style={{ fontFamily: '"Playfair Display", serif' }}
          data-testid="custom-page-title"
        >
          {page.title}
        </h1>

        <div
          className="prose prose-stone max-w-none text-stone-700 leading-relaxed whitespace-pre-line text-base md:text-lg"
          data-testid="custom-page-content"
        >
          {page.content}
        </div>
      </div>
    </div>
  );
};

export default CustomPage;
